import { useState, useEffect } from "react";
import { Popover, Box, Button, Divider } from "@mui/material";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CustomTextField from "components/mui/text-field";
import dayjs from "dayjs";

const DatePopover = ({ onChange, invoiceDetails, disabled }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [displayDate, setDisplayDate] = useState(null);

  const predefinedRanges = {
    "Tomorrow": dayjs().add(1, "day"),
    "One Week": dayjs().add(1, "week"),
    "Two Weeks": dayjs().add(2, "weeks"),
    "One Month": dayjs().add(1, "month"),
  };

  useEffect(() => {
    if (invoiceDetails?.sendByDueDate) {
      const dueDate = dayjs(invoiceDetails.sendByDueDate);
      setDisplayDate(dueDate);
      
      const foundRange = Object.entries(predefinedRanges).find(([_, date]) => 
        date.isSame(dueDate, 'day')
      );
      
      setSelectedFilter(foundRange ? foundRange[0] : "Custom");
    } else if (displayDate === null) {
      const defaultDate = dayjs().add(7, "days");
      setDisplayDate(defaultDate);
      setSelectedFilter("One Week");
      onChange('sendByDueDate', defaultDate);
    }
  }, [invoiceDetails]);

  const openPopover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const closePopover = () => {
    setAnchorEl(null);
  };

  const handleQuickFilter = (range) => {
    const date = predefinedRanges[range];
    setDisplayDate(date);
    onChange('sendByDueDate', date);
    setSelectedFilter(range);
  };

  const handleDateChange = (newDate) => {
    setDisplayDate(newDate);
    setSelectedFilter("Custom");
    onChange('sendByDueDate', newDate);
  };

  const isPopoverOpen = Boolean(anchorEl);

  if (displayDate === null) return null;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box>
        <Box onClick={openPopover} sx={{ cursor: "pointer" }}>
          <CustomTextField
            fullWidth
            disabled={disabled}
            InputProps={{
              readOnly: true,
              sx: {
                cursor: "pointer !important",
                "& .MuiInputBase-root": { cursor: "pointer !important" },
                "& .MuiInputBase-input": { cursor: "pointer !important" },
              },
            }}
            value={displayDate ? displayDate.format('MM/DD/YYYY') : 'Select a date'}
          />
        </Box>
        <Popover
          open={isPopoverOpen}
          anchorEl={anchorEl}
          onClose={closePopover}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 4,
              p: 4,
            }}
          >
            <Box display="flex" flexDirection="column" gap={2}>
              {Object.keys(predefinedRanges).map((range) => (
                <Button
                  key={range}
                  color="secondary"
                  variant={selectedFilter === range ? "contained" : "tonal"}
                  onClick={() => handleQuickFilter(range)}
                >
                  {range}
                </Button>
              ))}
            </Box>
            <Divider flexItem orientation="vertical" />
            <Box>
              <StaticDatePicker
                displayStaticWrapperAs="desktop"
                value={displayDate}
                onChange={handleDateChange}
              />
            </Box>
          </Box>
        </Popover>
      </Box>
    </LocalizationProvider>
  );
};

export default DatePopover;